module.exports = __webpack_public_path__ + "static/media/path.1b88ba23.svg";